<mat-card class="py-20" style="width: max-content; max-width: 100%; box-sizing: border-box;">
    <mat-card-header>
        <div class="g-just-flex flex-between w-100 flex-wrap" style="gap:16px;">
            <div class="left">
                <mat-card-title>Medications</mat-card-title>
                <mat-card-subtitle>Browse medication stock.</mat-card-subtitle>
            </div>
            <div class="right gap-10 g-just-flex" style="justify-content: flex-end;
    flex: 1;">
                @if (hasQueryParams) {
                <button mat-stroked-button (click)="clearSearch()">
                    <mat-icon>clear</mat-icon>
                    Clear search
                </button>
                }
                @if (canExportMedication$ | async) {
                <a mat-flat-button extended (click)="exportMedications()" class="secondary-button small-button">
                    <mat-icon>file_download</mat-icon>
                    Export
                </a>
                }
                @if (canAddMedication$ | async) {
                <a mat-flat-button extended (click)="importMedications()" class="secondary-button small-button me-8">
                    <mat-icon>upload_file</mat-icon>
                    Import
                </a>
                <a mat-flat-button extended (click)="addMedication()">
                    <mat-icon>add</mat-icon>
                    Add Medication
                </a>
                }
            </div>
        </div>
    </mat-card-header>

    <mat-card-content class="mt-20">
        @let medications = tableDataSource.data ?? [];
        @let isLoading = (loading$ | async) ?? false;

        @if (!hasQueryParams) {
        <app-table-header [patientsTableFilterArray]="medicationTableFilterArray"
            [patientsFiltersFormControlObject]="medicationFiltersFormControlObject"
            [hasData]="(medications.length > 0) || isLoading || !!searchTerm?.length || hasLoadedAnyRows"
            [showWhenSearching]="true" [searchableFields]="medicationSearchFieldOptions"
            [selectedSearchField]="selectedSearchField" (filterChanged)="onFilterChanged($event)"
            (searchCriteriaChanged)="onSearchCriteriaChanged($event)">
        </app-table-header>
        }
        <mat-divider></mat-divider>
        @if (error$ | async; as error) {
        <div class="error-text mt-16">{{ error }}</div>
        }

        @if (isLoading) {
        <div class="g-just-flex gap-10 mt-16" style="align-items: center;">
            <mat-progress-spinner diameter="28" strokeWidth="3" mode="indeterminate"></mat-progress-spinner>
            <span class="subtitle-text-color-2">Loading medications…</span>
        </div>
        }

        @if (medications.length > 0) {
        <table mat-table matSort [dataSource]="tableDataSource"
            class="restricted-columns mat-elevation-z8 demo-table mt-20">
            <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="status">Status</th>
                <td mat-cell *matCellDef="let med">
                    @if (med.status) {
                    <div [appChips]="med.status" [fontSize]="'14px'"></div>
                    } @else {
                    <span class="subtitle-text-color-2">N/A</span>
                    }
                </td>
            </ng-container>

            <ng-container matColumnDef="code">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="code" sticky>Medication</th>
                <td mat-cell *matCellDef="let med" style="white-space: normal; max-width: 300px;" sticky>
                    <div class="top  gap-5 justify-content-start "
                        style="white-space: normal;  align-items: flex-start; width: clamp(200px, 180px, 260px); max-width: 300px; box-sizing: border-box;">
                        <span class="me-8"> {{ med.code | codeableConcept2 | na | titlecase }}</span>
                        @if(med.expiredLabel){
                        <span [appEmphasis]="'expired'" [opacity]="0.7" [fontSize]="'13px'">expired</span>
                        }
                    </div>
                </td>
            </ng-container>

            <ng-container matColumnDef="form">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="form">Form</th>
                <td mat-cell *matCellDef="let med">
                    {{ med.form | codeableConcept2 | na | titlecase }}
                </td>
            </ng-container>

            <ng-container matColumnDef="manufacturer">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="manufacturer">Manufacturer</th>
                <td mat-cell *matCellDef="let med">
                    {{ med.manufacturer?.display ?? 'N/A' }}
                </td>
            </ng-container>

            <ng-container matColumnDef="amount">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="amount">Amount</th>
                <td mat-cell *matCellDef="let med">
                    <!-- {{med.amount | json}} -->
                    <div class="top mb-4">
                        @if (med.amount && (med.amount.numerator || med.amount.numeratorValue)) {
                        {{ med.amount.numerator?.value ?? med.amount.numeratorValue }} {{ med.amount.numerator?.unit ??
                        med.amount.numeratorUnit }}
                        } @else {
                        <span class="subtitle-text-color-2" style="font-size: 13px;">Unspecified</span>
                        }
                    </div>
                    <span class="subtitle-text-color-2"> {{ med.form | codeableConcept2 | na | titlecase }}</span>
                </td>
            </ng-container>

            <ng-container matColumnDef="in-stock">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="in-stock">Remaining Stock</th>
                <td mat-cell *matCellDef="let med">
                    @let inStock = med.inStockLabel ?? getRemainingInventory(med);
                    @if(inStock === 'out of stock'){
                    <span [appEmphasis]="'out-of-stock'" [opacity]="0.9">out of stock</span>
                    }@else{
                    <div class="g-just-flex gap-3 my-6" style="flex-direction: column; align-items: flex-start;">
                        <span> {{ inStock }}</span>
                        @if (med.lowStock) {
                        <span [appEmphasis]="'low'" [opacity]="0.85" [fontSize]="'12px'" [showBorder]="false"
                            [matTooltip]="med.lowStockLabel ?? 'Low stock threshold reached'">
                            {{ med.lowStockLabel ?? 'Low stock' }}
                        </span>
                        }

                    </div>
                    }

                </td>
            </ng-container>

            <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef>Actions</th>
                <td mat-cell *matCellDef="let med">
                    <button mat-icon-button (click)="showRow(med)">
                        <mat-icon>visibility</mat-icon>
                    </button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="medicationDisplayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: medicationDisplayedColumns;" class="py-6"></tr>
        </table>

        <mat-paginator class="mt-16" [length]="(total$ | async) ?? maxCacheRows" [pageSize]="pageSize"
            [pageSizeOptions]="[pageSize]" [showFirstLastButtons]="true" [hidePageSize]="true"
            [pageIndex]="paginatorPageIndex" (page)="onPageChange($event)"></mat-paginator>

        @if (unknownTotal$ | async) {
        <div class="caption subtitle-text-color-2 mt-6">Total count is unavailable; additional pages load while the
            server provides link.next references.</div>
        }
        } @else {
        <app-empty-state class="py-40" icon="MEDICAL_SERVICES" title="No medications found"
            subtitle="Add a medication to start tracking it here."></app-empty-state>
        }
    </mat-card-content>
</mat-card>